module.exports = __webpack_public_path__ + "static/media/a4651b48-72fb-4a4d-b7b7-7144c61ee8f5.d7bd68bb.png";